module.exports = __webpack_public_path__ + "img/Caution.69b0ce91.svg";